export default __webpack_public_path__ + "static/media/vid_completed.abc95c6c.svg";